type SummaryDetailMetricProps = {
  label: string;
  value?: number | string;
  theme?: "default" | "red" | "amber" | "green";
};

export const SummaryDetailMetric: React.FC<SummaryDetailMetricProps> = ({ label, value, theme = "default" }) => {
  const getBorderColor = () => {
    switch (theme) {
      case "red":
        return "border-rose-700/50 bg-rose-100";
      case "amber":
        return "border-amber-600/50 bg-amber-50";
      case "green":
        return "border-emerald-600/50 bg-emerald-50";
      default:
        return "border-slate-300";
    }
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <span className="text-xs font-bold">{label}</span>
      <div
        className={`flex min-h-7 min-w-7 items-center justify-center rounded-md border border-solid p-1 ${getBorderColor()}`}
      >
        <span className="text-sm font-bold">{value}</span>
      </div>
    </div>
  );
};
